import React, { useState, useEffect } from "react";
import { NavLink, Link, useLocation } from "react-router-dom";
import styles from "./Navbar.module.css";
import logo from "../assets/images/logo/1.png"; 

const NAV_LINKS = [
  { label: "HOME", path: "/" },
  { label: "ABOUT US", path: "/about-us" },
  // { label: "Software", path: "/software" },
  { label: "SERVICES", path: "/services" },
  { label: "IT TRAINING", path: "/training" },
  { label: "STAFFING", path: "/staffing" },
  { label: "INDUSTRIES", path: "/industries" },
  { label: "CONTACT US", path: "/contact-us" },

];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  // Close mobile menu on route change
  useEffect(() => {
    setMenuOpen(false);
  }, [pathname]);

  return (
    <header className={`${styles.header} ${scrolled ? styles.scrolled : ""}`}>
      <nav className={styles.nav}>
        {/* Logo */}
        <Link to="/" className={styles.logo}>
          <img src={logo} alt="MetaWave Logo" className={styles.logoImg} />
        </Link>
        
        {/* Desktop Links */}
        <ul className={styles.desktopLinks}>
          {NAV_LINKS.map(({ label, path }) => (
            <li key={path}>
              <NavLink
                to={path}
                end={path === "/"}
                className={({ isActive }) =>
                  `${styles.navLink} ${isActive ? styles.navLinkActive : ""}`
                }
              >
                {label}
              </NavLink>
            </li>
          ))}
        </ul>

        {/* Desktop CTA */}
        {/* <Link to="/contact" className={styles.ctaBtn}>
          Contact Us
        </Link> */}

        {/* Mobile Hamburger */}
        <button
          className={`${styles.hamburger} ${menuOpen ? styles.hamburgerOpen : ""}`}
          onClick={() => setMenuOpen((o) => !o)}
          aria-label="Toggle menu"
        >
          <span />
          <span />
          <span />
        </button>
      </nav>

      {/* Mobile Menu */}
      <div
        className={`${styles.mobileMenu} ${menuOpen ? styles.mobileMenuOpen : ""}`}
      >
        <ul>
          {NAV_LINKS.map(({ label, path }) => (
            <li key={path}>
              <NavLink
                to={path}
                end={path === "/"}
                className={({ isActive }) =>
                  `${styles.mobileLink} ${isActive ? styles.mobileLinkActive : ""}`
                }
              >
                {label}
              </NavLink>
            </li>
          ))}
          <li>
            <Link to="/contact" className={styles.mobileCta}>
              Contact Us
            </Link>
          </li>
        </ul>
      </div>
    </header>
  );
}
